// extracted by mini-css-extract-plugin
export default {"mainContainer":"TurtleVentre_mainContainer__XSE-e","padding":"TurtleVentre_padding__fGx0j","main":"TurtleVentre_main__PSULp","nextProj":"TurtleVentre_nextProj__cP0pq"};